import { useState, useEffect } from 'react';
import { getStoredLocation, isLocationValid } from '../utils/locationService';

/**
 * Custom React hook to access user's location data
 * @returns {Object} { location, isLoading, error, country, countryCode, city }
 */
export const useUserLocation = () => {
  const [location, setLocation] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadLocation = () => {
      try {
        const storedLocation = getStoredLocation();
        
        if (storedLocation && isLocationValid()) {
          setLocation(storedLocation);
          setError(null);
        } else {
          setError('No valid location data available');
        }
      } catch (err) {
        // console.error('Error loading location:', err);
        setError(err.message);
      } finally {
        setIsLoading(false);
      }
    };

    loadLocation();

    // Listen for localStorage changes (in case location is updated elsewhere)
    const handleStorageChange = (e) => {
      if (e.key === 'userLocation') {
        loadLocation();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  return {
    location,
    isLoading,
    error,
    country: location?.country || 'Unknown',
    countryCode: location?.countryCode || 'XX',
    city: location?.city || 'Unknown',
    latitude: location?.latitude || null,
    longitude: location?.longitude || null,
  };
};
